import { authService } from './auth.ts';
import { OrganizationService } from './organization.ts';

class OnboardingService {
  async createOrganization(name: string) {
    const org = await OrganizationService.getInstance().create(name);
    if (org && org.id) {
        await authService.switchOrganization(org.id);
    } else {
        await authService.getProfile();
    }
    return org;
  }

  async selectPlan(planId: string) {
    // In a real flow, this would trigger Stripe or update the subscription
    // For now, we'll call the updateSubscription endpoint if an org exists
    const profile = await authService.getProfile();
    if (profile && profile.org_id) {
      await OrganizationService.getInstance().updateSubscription(profile.org_id, planId);
      await authService.getProfile(); // Refresh
    }
  }

  async isFullyOnboarded(): Promise<boolean> {
    try {
      const profile = await authService.getProfile();
      
      const hasOrg = !!profile?.org_id;
      const hasPlan = !!profile?.plan_id;
      
      console.debug('>>> OnboardingService: isFullyOnboarded check:', { hasOrg, hasPlan, profile });
      
      return hasOrg && hasPlan;
    } catch (e) {
      console.error('Onboarding check failed:', e);
      return false;
    }
  }
}

export const onboardingService = new OnboardingService();
